import { h } from "preact";

import i18n from "../i18n";

export default function AppFooter() {
  return (
    <div class="app-footer">
      <span class="app-footer__section">{i18n.t("footer.copyright")}</span>
      <a
        href={`mailto:${i18n.t("feedback_mail")}`}
        class="app-footer__section subtle"
        data-tk-click="footer.link"
        data-tk-params='{"name":"feedback"}'
      >
        {i18n.t("footer.feedback")}
      </a>
      <a href="/privacy" class="app-footer__section subtle">
        {i18n.t("footer.privacy")}
      </a>
      <a href="/terms" class="app-footer__section subtle">
        {i18n.t("footer.terms")}
      </a>
      <a href="/imprint" class="app-footer__section subtle">
        {i18n.t("footer.imprint")}
      </a>
    </div>
  );
}
